import * as React from "react";
import { graphql } from "gatsby";
import { Seo } from '~/components/shared/seo'
import OurStores from '~/components/stores/OurStores'
import StoreDetail from '~/components/stores/StoreDetail'


const Store = ({ data: { store } }) => {

  return (
    <>
      {store.handle === 'our-stores' ? (
        <OurStores data={store} />
      ) : (
        <StoreDetail data={store} />
      )}
    </>
  )
}
export default Store

export const Head = ({ data: { store } }) => (
  <Seo 
    title={store.title}
    description={store.intro_message ? store.intro_message : store.title}
    image={store.metaimg}
    url={`/pages/${store.handle}`}
  />
)


export const pageQuery = graphql`
  query ($handle: String!) {
    store(handle: { eq: $handle }) {
      id
      handle
      title
      metaimg
      blocks
      title
      region
      short_name
      address_line_1
      address_line_2
      address_city
      address_state
      address_zip
      gmaps
      coordinates
      
      avail_mens
      avail_womens
      pickup_enabled
      avail_watches
      avail_coffee
      avail_vintclothes
      avail_books

      avail_curb_copy
      more
      hours
      phone

      detail_hero_image
      intro_message
      detail_image_col_1

      image_left
      image_right

      top_video
      hero_desk_video
      hero_mob_video
    }
  }
`;

